import { useTranslation } from 'react-i18next'
import { HiOutlinePlus } from 'react-icons/hi'
import { FormikErrors } from 'formik'
import { MdDelete } from 'react-icons/md'
import RenderIf from '../UI/RenderIf'
import ExistingFiles from '../../pages/Shared/pages/Newsletters/components/ExistingFiles'
import { useNewsletters } from '../../context/NewsletterCtx/NewslettersProvider'

interface Props {
  media: File[]
  setMedia: (field: string, value: any, shouldValidate?:
  (boolean | undefined)) => (Promise<FormikErrors<any>> | Promise<void>)
  onRemoveMediaHandler: (name: string) => void
  text?: string
  marginLeft?: 'ml-4' | 'ml-0'
  acceptedFiles: string
}

function FormUploadMedia({
  acceptedFiles, onRemoveMediaHandler, setMedia, media = [], marginLeft = 'ml-0', text
}:Props) {
  const { t } = useTranslation();
  const { existingFiles, isEditNewsletter } = useNewsletters()
  return (
    <div className={marginLeft}>
      <RenderIf isTrue={!!text}>
        <p className="text-grey-pale mb-5">{t(text!)}</p>
      </RenderIf>

      <RenderIf isTrue={existingFiles.length > 0 && isEditNewsletter}>
        <ExistingFiles />
      </RenderIf>

      <RenderIf isTrue={media.length > 0}>
        <div className="fex flex-col">
          {Array.from(media, (file, idx) => (
            <div key={idx} className="flex items-center mb-2 gap-3">
              <p>{file.name}</p>
              <MdDelete className="text-error cursor-pointer" size={20} onClick={() => onRemoveMediaHandler(file.name)} />
            </div>
          ))}

        </div>
      </RenderIf>

      <label htmlFor="complaintMedia" className="flex justify-center items-center rounded-lg bg-[#F1F1F1] w-[46px] h-[46px] cursor-pointer hover:opacity-80 transition-opacity duration-200">
        <HiOutlinePlus />
        <input
          id="complaintMedia"
          type="file"
          multiple
          accept={acceptedFiles}
          className="hidden"
          onClick={(event) => {
            // Reset file list
            const target = event.target as HTMLInputElement
            target.value = ''
          }}
          onChange={(event) => {
            setMedia('files', event.currentTarget.files)
          }}
        />
      </label>
    </div>
  )
}

export default FormUploadMedia
